"use client";

import { BSRSave } from "./bsr/BSRSave";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Save as LegacySave } from "./legacy/Save";

export const Save = createBSRExperimentIcon(LegacySave, BSRSave);
